/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { code3Formatter } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { GridOptionsExt, ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { JeTopViewUsageRecord } from '../../../resources/job-estimate-details.model';

@Injectable()
export class JeTopUsageGridDefinition extends ManualGridDefinition {
  constructor(private translationService: TranslationService) {
    super();
  }

  buildGridOptions(): GridOptionsExt {
    return {
      defaultColDef: {
        sortable: false,
      },
      getRowNodeAutomationId: (data: JeTopViewUsageRecord) => `${data.costCenterId}-${data.recordId}`,
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'costCenterCode',
      headerName: this.translationService.get('lbl_cost_center'),
      width: 200,
      valueFormatter: code3Formatter,
    }, {
      field: 'recordCode',
      headerName: this.translationService.get('lbl_code'),
      width: 400,
    }];
  }
}
